export default "__VITE_ASSET__DqATaF7t__"